import { render, staticRenderFns } from "./HuaBao.vue?vue&type=template&id=278000cf&scoped=true"
import script from "./HuaBao.vue?vue&type=script&lang=js"
export * from "./HuaBao.vue?vue&type=script&lang=js"
import style0 from "./HuaBao.vue?vue&type=style&index=0&id=278000cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278000cf",
  null
  
)

export default component.exports